export const H6 = ({ children = null, className = "" }) => (
  <div
    className={`H6 maax-font-weight-bold ${className}`}
    style={{
      fontSize: `18px`,
      lineHeight: `1.22`,
      color: `#4f4f58`,
    }}
    data-testid="H6"
  >
    {children}
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// H6.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// H6.defaultProps = {
//   children: null,
//   className: "",
// }
